import React from 'react';

import { Dates, type DATE_BEHAVIOR_ENUM } from 'venn-utils';

import { Block } from '../../core';

interface AsOfDateProps {
  holdingsData: { asOfDate?: number };
  dateBehavior: DATE_BEHAVIOR_ENUM;
}

export const AsOfDate = ({ holdingsData, dateBehavior }: AsOfDateProps) => {
  if (!holdingsData || dateBehavior !== 'SERVER_SENT') {
    return null;
  }
  const text = holdingsData.asOfDate ? `As of ${Dates.toDDMMMYYYY(holdingsData.asOfDate)}` : 'Most Recent Available';
  return <Block.MetadataItem iconType="calendar">{text}</Block.MetadataItem>;
};
